/**
 * Checks if debugging has been enabled in this browser context. To enable
 * debugging set the local storage key '@@loaded/debugEnabled' to a JS truthy
 * value.
 * @returns
 */
export default function () {
  return !!localStorage.getItem('@@loaded/debugEnabled')
}
